import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60dd456b")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: [_ctx.centerButton ? 'items-center justify-center' + ' ' + _ctx.flexButton : '', _ctx.cssClass]
  }, [
    _createVNode("a", {
      rel: "nofollow",
      class: ['cursor-pointer mx-auto lg:mx-0 bg-white ' +
		 'text-white dark:text-gray-900 font-bold rounded-full my-6 py-4 px-8 shadow-lg focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out','text-center rounded-md text-button  py-3 font-medium default-btn ' + _ctx.buttonWidth + ' ' + [_ctx.buttonColor.toString().length > 0 ? _ctx.buttonColor + ' btn-default-settings' : 'btn-main-color'] ],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToLink && _ctx.redirectToLink(...args)))
    }, _toDisplayString(_ctx.buttonText), 3)
  ], 2))
})